// 商品-创建
export default {
    tabel_title: "Product List",
    tl_shopImg: "Product image",
    tl_shopName: "Product Name",
    tl_price_serial: "Price/Item No.",
    tr_price: "Price:",
    tr_serial: "Item No.:",
    tl_specName: "Attribute",
    tl_number: "Number",
    tl_quantity: "Inventory",
    tl_amount: "Subtotal",
    statistical_desc: "Total item order:",

    // 新增商品
    dt_addGoods: "Add Goods",
    dl_search: "Search for products",
    dp_search: "product name/item number",
    btn_search: "Search",
    dl_category: "Category",
    dp_category: "category",
    dl_goodsName: "Goods Name",
    dp_goodsName: "goods Name",
    tag_new: "Online",
    tag_promotion: "Promotion",
    tag_hot: "hot",
    tag_recommend: "recommended",
    dl_goodsSerial: "Goods item number",
    dl_brand: "Brand",
    dl_price: "Price",
    dl_specs: "Properties",
    dp_specs: "Please select",
    dl_quantity: "Inventory",
    dl_number: "Number",
    dp_number: "Please enter",
    btn_addItem: "Add Order"
};
